import { render, staticRenderFns } from "./ResultOkrs.vue?vue&type=template&id=44b921ea&scoped=true"
import script from "./ResultOkrs.vue?vue&type=script&lang=js"
export * from "./ResultOkrs.vue?vue&type=script&lang=js"
import style0 from "./ResultOkrs.vue?vue&type=style&index=0&id=44b921ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b921ea",
  null
  
)

export default component.exports